
import React, { useContext } from 'react';
import { SettingsSearchContext } from './SettingsContext';

interface SectionLabelProps {
  children?: React.ReactNode;
  icon?: string;
  darkMode: boolean;
}

export const SectionLabel: React.FC<SectionLabelProps> = ({ children, icon, darkMode }) => {
  const searchQuery = useContext(SettingsSearchContext);
  
  if (searchQuery) return null; // Flatten list when searching

  return (
    <div className="w-full flex items-center gap-2 mt-6 mb-3">
      <div className={`flex-1 h-px ${darkMode ? 'bg-white/10' : 'bg-neutral-200'}`} />
      <span className="text-[10px] uppercase font-black tracking-[0.2em] opacity-60 whitespace-nowrap flex items-center gap-2">
        {icon && <i className={`fa-solid ${icon}`}></i>}
        {children}
      </span>
      <div className={`flex-1 h-px ${darkMode ? 'bg-white/10' : 'bg-neutral-200'}`} />
    </div>
  );
};
